import DialogComponent from "../main/DIalogComponent";
import AgencyForm from "../form/AgencyForm";
import CategoryForm from "../form/CategoryForm";
import DeleteCategory from "../agency/DeleteCategory";
import DocumentForm from "../form/DocumentForm";
import DeleteDocument from "../agency/DeleteDocument";
import DeleteAgency from "../agency/DeleteAgency";

type IProps = {
    type: 'update' 
        | 'add' 
        | 'delete' 
        | 'addCategory' 
        | 'updateCategory' 
        | 'deleteCategory'
        | 'addDocument'
        | 'updateDocument'
        | 'deleteDocument',
    label?: string,
    row?: any,
    idAzienda?: any,
    icon?: any,
    infoForm?: any,
    listCategories?: any
}

export default function AgencyAction({ idAzienda, label, type, icon, infoForm, listCategories }: IProps) {

    let selectedComponent = <></>;

    switch (type) {
        case 'update':
            selectedComponent = <AgencyForm type="update" />
            break;
        case 'add':
            selectedComponent = <AgencyForm type="add" />
            break;
        case 'delete':
            selectedComponent = <DeleteAgency idAzienda={idAzienda} dataInfo={infoForm} />
            break;
        case 'addCategory':
            selectedComponent = <CategoryForm idAzienda={idAzienda} type="add" />
            break;
        case 'updateCategory':
            selectedComponent = <CategoryForm idAzienda={idAzienda} type="update" dataInfo={infoForm}/>
            break;
        case 'deleteCategory':
            selectedComponent = <DeleteCategory idAzienda={idAzienda} dataInfo={infoForm} />
            break;
        case 'addDocument':
            selectedComponent = <DocumentForm type="add" idAzienda={idAzienda} dataInfo={infoForm} listCategories={listCategories} />
            break;
        case 'updateDocument':
            selectedComponent = <DocumentForm type="update" idAzienda={idAzienda} dataInfo={infoForm} listCategories={listCategories} />
            break;
        case 'deleteDocument':
            selectedComponent = <DeleteDocument idAzienda={idAzienda} dataInfo={infoForm} />
            break;
        default:
            break;
    }

    return (
        <DialogComponent
            className="!text-gray-400 !text-md"
            icon={icon || ''}
            label={label || ''}
            content={selectedComponent}
            size={(type === 'delete' || type === 'deleteDocument' || type === 'deleteCategory') ? 'sm' : undefined}
            type="specialTab"
        />
    )
}